const bmw2022 = {
  'yellow-600': '#FBBA00',
  'purple-600': '#140057',
}

export default bmw2022
